import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import ModalContainer from "../../components/modal/ModalContainer";

import { DialogContent,Divider, DialogActions,Paper, Button, Grid, TextField,Switch} from "@material-ui/core";
import CheckCircle from "@material-ui/icons/CheckCircle";
import ResponsiveTable from "../../components/table/ResponsiveTable";
import moment from "moment"
import currencyHelper from "../../helper/currency"
import { ProfileType, BookingType } from "../../types/enum";

export const isNoTaxInvoice = invoice =>
    !invoice || invoice.taxLabel === "NOT" || invoice.taxLabel === null || invoice.taxLabel === "";

export const getInvoiceTaxLabel = invoice => {
    if (isNoTaxInvoice(invoice)) {
        return "No tax";
    }

    if (invoice.taxLabel === "CUSTOM") {
        return `tax-${parseFloat(invoice.taxPercentage).toFixed(2)}%`;
    }

    return `${invoice.taxLabel}-${parseFloat(invoice.taxPercentage).toFixed(2)}%`;
};

@inject("agentVenueContactStore", "profileStore", "templateStore", "bookingRequestStore")
@observer
class InvoiceDetailsModal extends Component {
    sigCanvas = {};
    state = {
        isLoading: false,
        venueData: undefined
    }


    
    getColumns = () => {
        var columns = []
        if(this.props.hideReadyToPay){
            columns = [
                { key: "date", label: "Gig Date" },
                { key: "time", label: "Time" },
                { key: "description", label: "Description" },
                { key: "fee", label: "Fee" }
            ];
        }else{
            columns = [
                { key: "date", label: "Gig Date" },
                { key: "time", label: "Time" },
                { key: "description", label: "Description" },
                { key: "fee", label: "Fee" },
                ...[{ key: "readyToPayCheck", label: "Ready to Pay", align:"center"}],
            ];
        }
       
        return columns;
       
    };

    getColumns = () => {
        var columns = []
        if(this.props.hideReadyToPay){
            columns = [
                { key: "description", label: "Description" },
                { key: "tax", label: "Tax" },
                { key: "fee", label: "Fee" }
            ];
        }else{
            columns = [
                { key: "description", label: "description" },
                { key: "tax", label: "Tax" },
                { key: "fee", label: "Fee" },
                ...[{ key: "readyToPayCheck", label: "Ready to Pay", align:"center"}],
            ];
        }
       
        return columns;
       
    };


    onClose = () => {
        this.props.agentVenueContactStore.reset()
        this.props.onClose()
    }

    renderFooterRow = invoice => {
       
        if(invoice){
             var currency =  this.props.invoice?.payee?.currency
            return [{
                        fee: `Subtotal : ${currency + " " + currencyHelper.formatMoney(parseFloat(invoice.subTotal), 2)}`,
                    },
                {
                        fee: `${isNoTaxInvoice(invoice) ? "No tax" : "Tax"} : ${currency + " " + currencyHelper.formatMoney(parseFloat(invoice.tax), 2)}`,
                    },
                {
                        fee: `Total : ${currency + " " + currencyHelper.formatMoney(parseFloat(invoice.total), 2)}`,
                    }]
        }
    }


    
    render() {
        var invoice = this.props.invoice
        var currency =  this.props.invoice?.payee?.currency
        const {
            currentProfile
        } = this.props.profileStore;
     
        var taxLabel = getInvoiceTaxLabel(invoice);
        var bsbTitle = "BSB"
        if(currency === "USD"){
            bsbTitle = "Routing Number"
        }else if(currency === "GBP"){
            bsbTitle = "Sort Code"
        }else if(currency === "NZD"){
            bsbTitle = "Bank Code"
        }
        return (
            <ModalContainer open={this.props.open} onClose={this.onClose} onEntered={this.onEntered} title={this.props.title} coloredDialogTitle={true}>
                <DialogContent>
                    <Paper>
                        <div style={{ overflowX: "auto" }}>
                            { this.props.invoice && this.props.invoice.invoiceDetails && this.props.invoice.invoiceDetails.length ?
                            <ResponsiveTable
                                showToolbar={false}
                                selectable={false}
                                columns={this.getColumns()}
                                footerColumn = {this.renderFooterRow(invoice)}
                                rows={this.props.invoice?.invoiceDetails?.map(invoiceDetail => {
                                    var row = {};
                                    var descriptionText = `${invoiceDetail.description} - ${moment(invoiceDetail.date).format("DD/MM/YYYY")} - ${moment(invoiceDetail.timeStart, "HH:mm:ss").format("hh:mm a")} to ${moment(invoiceDetail.timeEnd, "HH:mm:ss").format("hh:mm a")}`;
                                    var isMobile = process.env.REACT_APP_IS_MOBILE === "true";

                                    const store = this.props.bookingRequestStore;
                                    const bookingList = store?.allGigs ? Array.from(store.allGigs) : [];
                                    const booking = bookingList.find((b) => b.id === invoiceDetail.bookingId);

                                    if (invoiceDetail.bookingId) {
                                        const bookingId = invoiceDetail.bookingId;

                                        const isEntertainerBookings = currentProfile?.type === ProfileType.Musician.ordinal &&
                                            booking?.createdById === currentProfile?.id &&
                                            !booking?.act?.actName;

                                        let redirectUrl =
                                            booking?.type === BookingType?.Adhoc?.ordinal
                                                ? `/privateBooking/${bookingId}/edit`
                                                : isEntertainerBookings
                                                    ? `/booking/${bookingId}/edit`
                                                    : currentProfile?.type === ProfileType.Musician.ordinal
                                                        ? `/musician/booking/${bookingId}/details`
                                                        : currentProfile?.type === ProfileType.Agent.ordinal
                                                            ? `/booking/${bookingId}/edit`
                                                            : currentProfile?.type === ProfileType.Staff.ordinal
                                                                ? `/booking/${bookingId}/edit`
                                                                : `/booking/${bookingId}/edit`;
                                        row.description = (
                                            <span>
                                                {descriptionText}
                                                {" "}
                                                <a
                                                    href={redirectUrl}
                                                    {...(!isMobile ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                                    style={{ color: "#1976d2", textDecoration: "none", whiteSpace: "nowrap" }}
                                                >
                                                    View Booking
                                                </a>
                                            </span>
                                        );
                                    } else {
                                        row.description = descriptionText;
                                    }
                                    row.tax= taxLabel
                                    row.fee = invoiceDetail.fee
                                    row.readyToPayCheck =  invoiceDetail.readyToPayCheck === 1?  <div style={{textAlign:"center", width:"100%"}}><CheckCircle style={{ texAlign:"center",color: "green"}} /></div> : null
                                    

                                    return row;
                                })}
                            /> : null
                            }
                        </div>
                    </Paper> 
                    {!this.props.hideReadyToPay ?
                    <table>
          
        <tr>
                <td class="payment-to">
                    {`Bank Account Name: ${invoice?.payeeAccountName}`}
                </td>
            </tr>
            <tr>
                <td class="payment-to">
                    {`${bsbTitle}: ${invoice?.payeeBsb}`}
                </td>
            </tr>
            <tr>
                <td class="payment-to">
                    {`Account Number: ${invoice?.payeeAccountNumber}`}
                </td>
            </tr>
        </table> : null }
        {parseFloat(invoice?.superFee) > 0 && invoice?.payer?.type != ProfileType.Venue.ordinal ? 
         <table style={{marginTop:20}}>
                    <tr>
                        <td class="payment-to">
                            Superannuation Guarantee (SG) Payable:
                        </td>
                    </tr>
                <tr>
                        <td class="payment-to">
                            {`$${parseFloat(invoice?.superFee).toFixed(2)} (at ${parseFloat(invoice?.superPercentage).toFixed(2)}%) — to be paid directly to the nominated super fund below.`}
                        </td>
                    </tr>
                    <tr>
                        <td class="payment-to">
                            {`Super Fund: ${invoice?.payee?.superAnnuationProfile?.fundName} - ${invoice?.payee?.superAnnuationProfile?.productName}`}
                        </td>
                    </tr>
                    <tr>
                        <td class="payment-to">
                            {`ABN: ${invoice?.payee?.superAnnuationProfile?.aBN}`}
                        </td>
                    </tr>
                    <tr>
                        <td class="payment-to">
                            {`USI: ${invoice?.payee?.superAnnuationProfile?.uSI}`}
                        </td>
                    </tr>
                    <tr>
                        <td class="payment-to">
                            {`Member Number: ${invoice?.payee?.superAnnuationProfile?.superFundMemberNumber}`}
                        </td>
                    </tr>
                </table> :  null}
                
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onClose}>Close</Button>
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default InvoiceDetailsModal;
